import React, { useState } from 'react';

const Abonnement = () => {
  const [abonnement, setAbonnement] = useState({
    nom: 'Abonnement Deezer',
    fournisseur: 'Deezer',
    montant: '9.99',
    dateDebut: '2025-01-01',
    dateFin: '2025-12-31',
    frequence: 'mensuel',
    categorie: 'Logiciel',
    statut: 'actif',
    reference: 'REF-2025-001',
  });

  const [editMode, setEditMode] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAbonnement({
      ...abonnement,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEditMode(false);
    alert('Abonnement enregistré avec succès !');
  };

  return (
    <div className="gestion-abonnement-comptable">
      <h2>Gestion des abonnements</h2>

      {!editMode ? (
        <div className="details-abonnement">
          <p><strong>Nom :</strong> {abonnement.nom}</p>
          <p><strong>Fournisseur :</strong> {abonnement.fournisseur}</p>
          <p><strong>Montant :</strong> {abonnement.montant} €</p>
          <p><strong>Date de début :</strong> {abonnement.dateDebut}</p>
          <p><strong>Date de fin :</strong> {abonnement.dateFin}</p>
          <p><strong>Fréquence :</strong> {abonnement.frequence}</p>
          <p><strong>Catégorie :</strong> {abonnement.categorie}</p>
          <p><strong>Statut :</strong> {abonnement.statut}</p>
          <p><strong>Référence :</strong> {abonnement.reference}</p>
          <button onClick={() => setEditMode(true)}>Modifier</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="formulaire-abonnement">
          <div>
            <label>
              Nom de l’abonnement :
              <input
                type="text"
                name="nom"
                value={abonnement.nom}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <div>
            <label>
              Fournisseur :
              <input
                type="text"
                name="fournisseur"
                value={abonnement.fournisseur}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <div>
            <label>
              Montant (€) :
              <input
                type="number"
                name="montant"
                value={abonnement.montant}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <div>
            <label>
              Date de début :
              <input
                type="date"
                name="dateDebut"
                value={abonnement.dateDebut}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          <div>
            <label>
              Date de fin :
              <input
                type="date"
                name="dateFin"
                value={abonnement.dateFin}
                onChange={handleChange}
              />
            </label>
          </div>

          <div>
            <label>
              Fréquence :
              <select
                name="frequence"
                value={abonnement.frequence}
                onChange={handleChange}
              >
                <option value="mensuel">Mensuel</option>
                <option value="trimestriel">Trimestriel</option>
                <option value="annuel">Annuel</option>
              </select>
            </label>
          </div>

          <div>
            <label>
              Catégorie :
              <select
                name="categorie"
                value={abonnement.categorie}
                onChange={handleChange}
              >
                <option value="Logiciel">Logiciel</option>
                <option value="Service">Service</option>
                <option value="Assurance">Assurance</option>
                <option value="Autre">Autre</option>
              </select>
            </label>
          </div>

          <div>
            <label>
              Statut :
              <select
                name="statut"
                value={abonnement.statut}
                onChange={handleChange}
              >
                <option value="actif">Actif</option>
                <option value="inactif">Inactif</option>
                <option value="résilié">Résilié</option>
              </select>
            </label>
          </div>

          <div>
            <label>
              Référence :
              <input
                type="text"
                name="reference"
                value={abonnement.reference}
                onChange={handleChange}
              />
            </label>
          </div>

          <button type="submit">Enregistrer</button>
          <button type="button" onClick={() => setEditMode(false)}>Annuler</button>
        </form>
      )}
    </div>
  );
};

export default Abonnement;
